import React, { useContext, useEffect, useState } from 'react';
import { appContext } from '../../App';
import { onDbChange, detachListener, adminSignOut } from '../../firebase/firebase';
import MessageDetails from '../message-list/MessageDetails';
import { lists, lang } from '../../util/constants';
import Spinner from 'react-bootstrap/Spinner';
import { GrLogout } from 'react-icons/gr';



const Admin = (props: any) => {

   const [currentStatus, setCurrentStatus] = useState<string>(lists.unchecked);
   const [currentList, setCurrentList] = useState<any[]>([]);
   const [unapprovedCount, setUnapprovedCount] = useState<number>(0);
   const [forceUp, setForceUp] = useState(0);

   const { messages, setMessages } = useContext(appContext);

   useEffect(() => {
      onDbChange(setMessages);

      return () => {
         detachListener();
      }
   }, []);

   useEffect(() => {
      setCurrentList(filterMessages());
      if (currentStatus === lists.unchecked && currentList.length !== unapprovedCount) setUnapprovedCount(currentList.length);
   }, [currentStatus, messages, currentList.length])


   function filterMessages() {
      return messages.filter(msg => msg.status === currentStatus)
   }

   function forceUpdate() {
      setForceUp(forceUp + 1);
   }

   return (
      <div className='admin-container padd-admin'>
         <div className='d-flex justify-content-between'>
            <h2>Olá Kalytinha!</h2>
            <div className='admin-logout d-flex flex-column justify-content-center' onClick={adminSignOut}>
               <div className='a-logout-icons text-center'><GrLogout /></div>
               <small>Log out</small>
            </div>
         </div>

         {
            unapprovedCount === 0 && messages.length ? <p>Você não tem novas mensagens</p> : null
         }
         {
            unapprovedCount > 0 && messages.length ? <p>Você tem {unapprovedCount} menssage{unapprovedCount === 1 ? 'm nova' : 'ns novas'}</p> : null
         }

         <div className='form-group'>
            <select className='form-control' onChange={e => setCurrentStatus(e.currentTarget.value)}>
               <option value={lists.unchecked}>Não lidas</option>
               <option value={lists.approved}>Aprovadas</option>
               <option value={lists.deleted}>Apagadas</option>
            </select>
         </div>

         <div className='a-msg-list-container'>
            <div className='message-list-container'>
               {
                  messages.length ?
                  currentList.map((msg: any) => {
                     return (
                        <MessageDetails 
                           key={msg.date} 
                           msg={msg} 
                           currentList={currentStatus}
                           forceUpdate={forceUpdate}
                           lang={lang}
                        />
                     )
                  }) :
                  null
               }
               {
                  !messages.length &&
                  <div className='spinner-container d-flex justify-content-center align-items-center'>
                     <Spinner animation="border" variant="primary" />
                  </div>
               }
            </div>
         </div>
      </div>
   )
}

export default Admin
